module.exports = __webpack_public_path__ + "img/loginLeft.0f6da2bd.png";